import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Input, Button, Modal, Row, Col } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import _ from "lodash";
import { useDispatch, useSelector } from "react-redux";
import { FC } from "react";
import { RootState } from "reducers/rootReducer";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Pie } from "react-chartjs-2";
import {SocketTopics} from "../../constants/enums"
import {wrapRequestPayload} from '../../helpers/request/RequestPayload'
import {
  getCreateEventPagePublishTopic
} from "hooks/MQTTConstants";

ChartJS.register(ArcElement, Tooltip, Legend);

const VideoRecorderModal: FC<{ onClose?: () => void, socket?: any }> = ({ onClose, socket }) => {
  const [isModalVisible, setIsModalVisible] = useState<boolean>(true);
  const [redrawCount, setRedrawCount] = useState<number>(0);
  const { videoIot } = useSelector((state: RootState) => state.auth);
  const [objectMap, setObjectMap] = useState<any>({
    person: { count: 0, label: "Person" },
    bicycle: { count: 0, label: "Bike" },
    car: { count: 0, label: "Vehicle" },
    airplane: { count: 0, label: "FlyingO" },
    bird: { count: 0, label: "Bird" },
    cat: { count: 0, label: "Animal" },
    train: { count: 0, label: "Train" },
  });
  const [key, setKey] = useState<string>("");
  const [chartData, setChartData] = useState<any>({
    labels: ["Person", "Bike", "Vehicle", "FlyingO", "Bird", "Animal", "Train"],
    datasets: [
      {
        label: "Object detection",
        data: [1, 0, 0, 0, 0, 0, 0],
        backgroundColor: [
          "#40CC52",
          "#FF5F25",
          "#FBAE16",
          "#463BBD",
          "#91A5C6",
          "#508AFA",
          "#000",
        ],
        borderWidth: 1,
      },
    ],
  });

  const handleCancel = () => {
    setIsModalVisible(false);
    onClose && onClose();
  };

  const dispatch = useDispatch();
  const handleOk = () => {
    // if (key !== undefined && key !== "") {
    //   dispatch({
    //     type: "SEND_MESSAGE",
    //     payload: {
    //       message: key,
    //       type: "video-recorder",
    //       data: { title: key, deviceKey: key },
    //     },
    //   });
    // }
    // setIsModalVisible(false);
  };

  const createDispatchingEventPage = () => {
    socket.publishToEvent(
      SocketTopics.PublishPageTopics,
      getCreateEventPagePublishTopic(localStorage.getItem('CID')),
      wrapRequestPayload({
        userId: localStorage.getItem('RID'),
        attributes: {
          incidentType: "96cec65d-ec0b-4a18-bb13-f2915abf6773",
          incidentName: "Emergency",
          incidentTrigger: 'Train detected',
          protocol: 'High priority',
          incidentLocation: {
            type: 'location',
            coordinates: {
              "lat": 47.510320,
              "long": 19.029817
            },
            attributes: {
              title: 'Incident location',
              address: 'Budapest, 67 Margit Korut'
            }
          }
        },
        responders: [{id: '20040'}],
        assets: [],
        connectionId: localStorage.getItem('CID'),
        submitted: true,
      })
    );
  }

  useEffect(() => {
    if (videoIot) {
      const samples = videoIot?.samples?.[0].dataset;
      if (samples) {
        let objectMapTemp = { ...objectMap };
        let chartDataTemp = { ...chartData };
        Object.keys(objectMapTemp).map((key) => {
          objectMapTemp[key].count = 0;
        });
        Object.keys(samples).map((key) => {
          if (objectMapTemp[key]) {
            objectMapTemp[key].count = samples[key];
          }
        });
        setObjectMap(objectMapTemp);

        let seriesData = [];
        Object.keys(objectMapTemp).map((key) => {
          seriesData.push(objectMap[key].count);
        });
        chartDataTemp.datasets[0].data = seriesData;
        setChartData(chartDataTemp);
        setRedrawCount(redrawCount + 1)
        if(objectMapTemp.train.count > 0){
          dispatch({
            type: "SEND_MESSAGE",
            payload: {
              message: 'Train detected',
              type: "text",
              data: { notify: true },
            },
          });
          setTimeout(()=>{
            dispatch({
              type: "SEND_MESSAGE",
              payload: {
                message: 'Dispatching the event',
                type: "text",
                data: { notify: true },
              },
            });
            createDispatchingEventPage();
          }, 3000)

          setTimeout(()=>{
            dispatch({
              type: "SEND_MESSAGE",
              payload: {
                message: 'Assigned Test.responder to the event page',
                type: "text",
                data: { notify: true },
              },
            });
          }, 5000)
          dispatch({ type: "VIDEO_IOT", payload: undefined });
        }
      }
    }
  }, [videoIot]);

  return (
    <Modal
      title="Video Detector"
      visible={isModalVisible}
      onOk={handleOk}
      onCancel={handleCancel}
      width="480px"
      className="beam-modal"
      footer={[]}
      destroyOnClose={true}
    >
      <Row>
        <Col span={24}>
            <Pie key={redrawCount} data={chartData} redraw/>
        </Col>
      </Row>
    </Modal>
  );
};

export default VideoRecorderModal;
